export default __webpack_public_path__ + "static/media/screen1.4652efb0.png";